// extracted by mini-css-extract-plugin
export var bodyRow = "_e0-d";
export var cardColumns = "_e0-e";
export var ellipsesOverflow = "_e0-2";
export var flatBottomCorners = "_e0-3";
export var flatTopCorners = "_e0-4";
export var headerActionsDropdown = "_e0-f";
export var headerBottomRow = "_e0-c";
export var headerTopRow = "_e0-b";
export var orderDetailsWrapper = "_e0-0";
export var orderInfoContainer = "_e0-1";
export var productDetails = "_e0-9";
export var productImage = "_e0-5";
export var responsiveTable = "_e0-8";
export var shipmentContainer = "_e0-a";
export var tableBottomLeft = "_e0-6";
export var tableBottomRight = "_e0-7";
export var trackingLink = "_e0-g";